module.exports = __webpack_public_path__ + "static/media/t-whatsapp.ca50a0f9.svg";